import React, {useState} from "react";
import { Table } from "antd";
import { useSelector } from "react-redux";
import dayjs from "dayjs";

const BranchTransferReceiveTable = ({ printMode = false }) => {
  const { list, filters, loading } = useSelector(
    (state) => state.branchTransferReceive
  );

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
  });

  const handleTableChange = (pagination) => {
    setPagination(pagination);
  };

  const withoutDetailsColumns = [
    { title: "No.", render: (_, __, index) => index + 1 },
    {
      title: "Date",
      dataIndex: "tran_date",
      render: (val) => (val ? dayjs(val).format("DD-MM-YYYY") : "-"),
    },
    { title: "Branch Name", dataIndex: "name" },
    { title: "From Account", dataIndex: "from_acc_name" },
    { title: "To Account", dataIndex: "to_acc_name" },
    { title: "Tran By", dataIndex: "full_name" },
    { title: "Amount", dataIndex: "tran_amount", align: "right" },
  ];

  const withDetailsColumns = [
    { title: "No.", render: (_, __, index) => index + 1 },
    { title: "Voucher", dataIndex: "con_code" },
    {
      title: "Date",
      dataIndex: "tran_date",
      render: (val) => (val ? dayjs(val).format("DD-MM-YYYY") : "-"),
    },
    { title: "Customer", dataIndex: "acc_name" },
    { title: "Receipt By", dataIndex: "full_name" },
    { title: "Receipt Into", dataIndex: ["details", 0, "into_acc_name"] },
    {
      title: "Receipt Amount",
      dataIndex: ["details", 0, "con_total"],
      align: "right",
    },
  ];

  const columns =
    filters.recordType === "with details"
      ? withDetailsColumns
      : withoutDetailsColumns;

  // Grand Total
  const grandTotal = list.reduce((sum, row) => {
    if (filters.recordType === "with details") {
      return sum + (row.con_total || 0);
    }
    return sum + (row.tran_amount || 0);
  }, 0);

  if (printMode) {

  if (filters.recordType === "with details") {
    return (
      <table className="btr-print-table">
        <colgroup>
          <col style={{ width: "5%" }} />
          <col style={{ width: "14%" }} />
          <col style={{ width: "12%" }} />
          <col style={{ width: "24%" }} />
          <col style={{ width: "15%" }} />
          <col style={{ width: "18%" }} />
          <col style={{ width: "12%" }} />
        </colgroup>

        <tbody>
          <tr className="btr-print-heading">
            <td>No.</td>
            <td>Voucher</td>
            <td>Date</td>
            <td>Customer</td>
            <td>Receipt By</td>
            <td>Receipt Into</td>
            <td style={{ textAlign: "right" }}>
              Receipt Amount
            </td>
          </tr>

          {list.map((row, index) => (
            <tr key={row.id || index}>
              <td>{index + 1}</td>
              <td>{row.con_code}</td>

              <td>
                {row.tran_date
                  ? dayjs(row.tran_date).format("DD-MM-YYYY")
                  : "-"}
              </td>

              <td>{row.acc_name}</td>
              <td>{row.full_name}</td>
              <td>{row?.details?.[0]?.into_acc_name}</td>

              <td style={{ textAlign: "right" }}>
                {Number(
                  row?.details?.[0]?.con_total || 0
                ).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </td>
            </tr>
          ))}

          <tr className="btr-print-total">
            <td colSpan={6} style={{ textAlign: "right" }}>
              Grand Total
            </td>

            <td style={{ textAlign: "right" }}>
              {grandTotal.toFixed(2)}
            </td>
          </tr>
        </tbody>
      </table>
    );
  }

  return (
    <table className="btr-print-table">
      <colgroup>
        <col style={{ width: "5%" }} />
        <col style={{ width: "12%" }} />
        <col style={{ width: "18%" }} />
        <col style={{ width: "22%" }} />
        <col style={{ width: "22%" }} />
        <col style={{ width: "11%" }} />
        <col style={{ width: "10%" }} />
      </colgroup>

      <tbody>
        <tr className="btr-print-heading">
          <td>No.</td>
          <td>Date</td>
          <td>Branch Name</td>
          <td>From Account</td>
          <td>To Account</td>
          <td>Tran By</td>
          <td style={{ textAlign: "right" }}>Amount</td>
        </tr>

        {list.map((row, index) => (
          <tr key={row.id || index}>
            <td>{index + 1}</td>

            <td>
              {row.tran_date
                ? dayjs(row.tran_date).format("DD-MM-YYYY")
                : "-"}
            </td>

            <td>{row.name}</td>
            <td>{row.from_acc_name}</td>
            <td>{row.to_acc_name}</td>
            <td>{row.full_name}</td>

            <td style={{ textAlign: "right" }}>
              {Number(row.tran_amount || 0).toLocaleString(
                undefined,
                {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }
              )}
            </td>
          </tr>
        ))}

        <tr className="btr-print-total">
          <td colSpan={6} style={{ textAlign: "right" }}>
            Grand Total
          </td>

          <td style={{ textAlign: "right" }}>
            {grandTotal.toFixed(2)}
          </td>
        </tr>
      </tbody>
    </table>
  );
}

  return (
    <Table
      rowKey="id"
      columns={columns}
      dataSource={list}
      loading={loading}
      bordered
      scroll={{ x: "max-content" }}
      pagination={{
        ...pagination,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "50"],
      }}
      onChange={handleTableChange}
      summary={() => (
        <Table.Summary.Row>
          <Table.Summary.Cell index={0} colSpan={columns.length - 1} align="right">
            <strong>Grand Total</strong>
          </Table.Summary.Cell>
          <Table.Summary.Cell index={columns.length - 1} align="right">
            <strong>{grandTotal.toFixed(2)}</strong>
          </Table.Summary.Cell>
        </Table.Summary.Row>
      )}
    />
  );
};

export default BranchTransferReceiveTable;
